// extracted by mini-css-extract-plugin
export default {"tab":"shzRcB6aJmXaA10YZnzb","tabActive":"YvQG3NVJ3F6IAwbLkuKq"};